import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

// A janela mostra a escala "large" (800 px na maior dimensão). O Plone não
// gera escala maior que a original: numa foto com menos de 800 px de largura
// não há "large", e a janela usa a original, que já é pequena.
export const ESCALA_DA_JANELA = 'large';

// Dados da imagem no resumo do @search (coluna image_scales do catálogo).
export function infoDaImagem(foto) {
  const campo = foto?.image_field || 'image';
  const info = foto?.image_scales?.[campo]?.[0];
  return info?.download ? info : null;
}

export const temImagem = (foto) => infoDaImagem(foto) !== null;

// O resumo traz o download relativo à imagem (@@images/…); se vier absoluto,
// vira caminho do site.
function urlDe(foto, download) {
  if (/^(https?:)?\/\//.test(download) || download.startsWith('/')) {
    return flattenToAppURL(download);
  }
  return `${flattenToAppURL(foto['@id'])}/${download}`;
}

const comoEscala = (foto, entrada) => ({
  url: urlDe(foto, entrada.download),
  width: entrada.width,
  height: entrada.height,
});

export function escalaDaJanela(foto) {
  const info = infoDaImagem(foto);
  if (!info) return null;
  const large = info.scales?.[ESCALA_DA_JANELA];
  return comoEscala(foto, large?.download ? large : info);
}

// "Ver em tamanho maior": a maior escala gerada pelo Plone, nunca a original,
// que numa foto de celular passa de 3 MB. Costuma ser a huge (1600 px), mas
// nem sempre: numa foto menor que isso a huge não existe e a maior é a large,
// ou a que sobrar. Só existe se for maior que a foto já mostrada na janela.
export function escalaMaior(foto) {
  const info = infoDaImagem(foto);
  if (!info) return null;
  const janela = escalaDaJanela(foto);
  const maior = Object.values(info.scales || {})
    .filter((e) => e?.download && e.width)
    .sort((a, b) => b.width - a.width)[0];
  if (!maior || maior.width <= janela.width) return null;
  return comoEscala(foto, maior);
}
